import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcTags = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "m3.371 13.986 2.332 6.412a1.5 1.5 0 0 0 2.08.829l1.661-.83-6.073-6.41Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M5.415 3.328a1.5 1.5 0 0 0-1.288 1.288l-.691 5.18a2.5 2.5 0 0 0 .663 2.05l7.12 7.515a1.5 1.5 0 0 0 2.149.029l6.82-6.82a1.5 1.5 0 0 0-.028-2.15L12.645 3.3a2.5 2.5 0 0 0-2.05-.663l-5.18.69Zm4.863 4.651a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcTags");

export { IcTags };
//# sourceMappingURL=ic-tags.js.map
